module.exports = __webpack_public_path__ + "static/img/schaibaoBtn.117b5c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/schaibaoBtn.png
// module id = mpfV
// module chunks = 0